export default "__VITE_ASSET__BUF7OwBC__"